import Decor from './Decor';

export default Decor;
